// extracted by mini-css-extract-plugin
export var actionButton = "_8d-0";
export var attachmentLine = "_8d-1";
export var fileInput = "_8d-2";
export var fileUploadWrapper = "_8d-4";
export var footer = "_8d-3";
export var modalContent = "_8d-5";
export var paperclip = "_8d-6";
export var quillEditor = "_8d-7";